import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

export const DIALOG_TYPE = 'reminders-disabled';

@Component({
  selector: 'app-reminders-disabled-dialog',
  templateUrl: './reminders-disabled-dialog.component.html',
  styleUrls: ['./reminders-disabled-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemindersDisabledDialogComponent implements OnInit {
  dialogType: string;

  constructor() {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
  }
}
